export default function EmptyState({ icon, title, description }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-24 h-24 mb-6 text-slate-600">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-slate-300 mb-2">{title}</h3>
      {description && <p className="text-sm text-slate-500 text-center max-w-xs">{description}</p>}
    </div>
  );
}

export function BoilerEmptyIcon() {
  return (
    <svg viewBox="0 0 100 100" fill="none" className="w-full h-full">
      <rect x="20" y="30" width="60" height="50" rx="8" stroke="currentColor" strokeWidth="2" />
      <circle cx="50" cy="55" r="12" stroke="currentColor" strokeWidth="2" strokeDasharray="4 2" />
      <path d="M35 20 L35 30 M50 15 L50 30 M65 20 L65 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M30 85 L30 80 M70 85 L70 80" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="50" cy="55" r="4" fill="currentColor" opacity="0.3" />
    </svg>
  );
}

export function ClientEmptyIcon() {
  return (
    <svg viewBox="0 0 100 100" fill="none" className="w-full h-full">
      <circle cx="50" cy="35" r="15" stroke="currentColor" strokeWidth="2" />
      <path d="M25 80 C25 60 40 50 50 50 C60 50 75 60 75 80" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M40 35 L45 40 L55 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
    </svg>
  );
}

export function SearchEmptyIcon() {
  return (
    <svg viewBox="0 0 100 100" fill="none" className="w-full h-full">
      <circle cx="42" cy="42" r="22" stroke="currentColor" strokeWidth="2" />
      <path d="M58 58 L75 75" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M35 42 L49 42 M42 35 L42 49" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.3" />
    </svg>
  );
}

export function ChartEmptyIcon() {
  return (
    <svg viewBox="0 0 100 100" fill="none" className="w-full h-full">
      <path d="M15 75 L85 75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M15 75 L15 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M25 60 L40 45 L55 55 L75 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4 4" />
      <circle cx="25" cy="60" r="3" fill="currentColor" opacity="0.5" />
      <circle cx="40" cy="45" r="3" fill="currentColor" opacity="0.5" />
      <circle cx="55" cy="55" r="3" fill="currentColor" opacity="0.5" />
      <circle cx="75" cy="30" r="3" fill="currentColor" opacity="0.5" />
    </svg>
  );
}
